import React, { useMemo } from "react";
import "./ImageTiles2.css";
import { useSelector } from "react-redux";
import * as posterImage from "../../utils/usePosterImage";
import { ARTICLE_DETAILS, CONTENT_DETAILS } from "../../constants/strings";
import parse from "html-react-parser";
import { useGetLink } from "../../utils/useOpenLink";
import CustomLink from "../../utils/customLink";
import useCustomTranslation from "../../utils/useCustomTranslation";
import { Swiper, SwiperSlide } from "swiper/react";
import { swiperCarousel } from "../../utils/carouselFunction";
import { APP_COLORS } from "../../constants/styles";

function ImageTiles2({ contents: contentsArray, block_source, colors: colorObj }) {
    const content = useSelector((state) => state.layout.content);

    const { getLink } = useGetLink();

    const { direction, t } = useCustomTranslation();

    const contentReferenceData = useMemo(() => {
        if (block_source === ARTICLE_DETAILS) {
            if (contentsArray?.[0]?.contentKey) {
                const contentKey = contentsArray[0].contentKey;
                const respKeys = content[contentKey];
                let resp = respKeys?.map((k) => content[k]) || [];
                resp = JSON.parse(JSON.stringify(resp));

                for (const element of resp) {
                    if (element?.link) {
                        element.posterImage = posterImage.usePosterImage(
                            element.link,
                            element.image,
                        );
                    }
                }
                return resp;
            }
        } else {
            const arr = contentsArray
                .filter((c) => c.content_source === "Content")
                .map((c) => ({
                    image: c.content_image,
                    title: c.heading,
                    summary: c.body,
                    contentLink: c.content_reference,
                    type: c.type,
                    content_source: c.content_source,
                    sub_contents: c.contents,
                    content_buttons: c.content_buttons,
                }));

            return arr;
        }

        return [];
    }, [block_source, contentsArray, content]);

    return (
        <div className="image-tile-container" style={APP_COLORS(colorObj)}>
            <div className="container">
                <div className="col-12">
                    <Swiper dir={direction} key={direction} {...swiperCarousel}>
                        {contentReferenceData.map((card, i) => (
                            <SwiperSlide key={card.title}>
                                <div key={i} className="image-tile-card">
                                    <div className="aspect-w-16 aspect-h-9">
                                        <CustomLink
                                            to={getLink(
                                                card.path,
                                                card.type,
                                                card.language,
                                                card.link,
                                            )}
                                            type={card.type}
                                            link={card.link}
                                        >
                                            <img
                                                src={card?.image?.src}
                                                className="image-tile-image"
                                            />
                                        </CustomLink>
                                    </div>

                                    <div className="image-tile-content">
                                        <h3 className="image-tile-title">{card?.title}</h3>
                                        <p className="image-tile-description">
                                            {parse(card?.summary)}
                                        </p>

                                        {block_source === ARTICLE_DETAILS && (
                                            <CustomLink
                                                to={getLink(
                                                    card.path,
                                                    card.type,
                                                    card.language,
                                                    card.link,
                                                )}
                                                type={card.type}
                                                link={card.link}
                                            >
                                                <span className="image-tile-learn-more">
                                                    {t("btnText.learnMore")}
                                                </span>
                                            </CustomLink>
                                        )}

                                        {block_source === CONTENT_DETAILS &&
                                            card.sub_contents &&
                                            card.sub_contents.map((sub, i) => (
                                                <div className="image-tile-highlight" key={i}>
                                                    <div className="image-tile-highlight-line"></div>
                                                    <h2 className="image-tile-highlight-heading">
                                                        {sub.heading}
                                                    </h2>
                                                    {card?.content_buttons?.length > 0 &&
                                                        card?.content_buttons.map((v) => (
                                                            <CustomLink
                                                                to={getLink(v.action)}
                                                                key={v.label}
                                                            >
                                                                <span className="image-tile-learn-more">
                                                                    {v.label}
                                                                </span>
                                                            </CustomLink>
                                                        ))}
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
}

export default ImageTiles2;
